<template>
  <div id="app" class="vue-my-database-page" style="height:100%;">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue